import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setTransectionType, setPageNo, setReset, setSearch } from '../features/filter/filterSlice';
import { fetchTransactions } from '../features/transaction/transactionSlice';
import { useEffect } from 'react';

export default function ListFilter() {
  const dispatch = useDispatch();

  const { transectionType, search, pageNo } = useSelector((state) => state.filter);

  const [type, setType] = useState("");
  const [title, setTitle] = useState(search);

  const searchHandler = (e) => {
    e.preventDefault();
    if (!title) {
      dispatch(
        fetchTransactions({ pageNo, limit: 5, type: transectionType, search })
      );
    }
    dispatch(setPageNo(1));
    dispatch(setSearch(title));
    setTitle(search);
  };

  useEffect(() => {
    setTitle(search);
  }, [search]);


  return (
    <div>
      <div className="form-group radio">
        <div className="radio_group">
          <input
            required
            type="radio"
            value="income"
            name="type"
            checked={type === "income"}
            onChange={(e) => {
              setType("income");
              dispatch(setTransectionType("income"));
              dispatch(setPageNo(1));
            }}
          />
          <label>Income</label>
        </div>
        <div className="radio_group">
          <input
            type="radio"
            value="expense"
            name="type"
            placeholder="Expense"
            checked={type === "expense"}
            onChange={(e) => {
              setType("expense");
              dispatch(setTransectionType("expense"));
              dispatch(setPageNo(1));
            }}
          />
          <label>Expense</label>
        </div>
      </div>
      <form onSubmit={searchHandler}>
        <div className="form-group">
          <input
            type="text"
            name="title"
            placeholder="enter title"
            value={title}
            onChange={(e) => {
              setTitle(e.target.value)
            }}
          />
        </div>
      </form>
      {(transectionType || search) && (
        <div
          className={`reset-btn expense`}
          style={{ cursor: "pointer" }}
          onClick={(e) => {
            e.stopPropagation();
            dispatch(setReset());
            setType("");
          }}
        >
          Reset
        </div>
      )}
    </div>
  )
}
